import { useNavigation } from '@react-navigation/core'
import { createStackNavigator } from '@react-navigation/stack'
import { lazy, useEffect } from 'react'
import { loginStrings } from '../../data/static/strings'
import { isSessionValid, safelyParseJSON } from '../../util/util'
import { Routes } from '../routes'
import ForgotPassword from '../../screens/ForgotPassword/';
import ResetPassword from '../../screens/ResetPassword/';


const LoginNavStrings = {
  forgotPassword: 'forgotPassword',
  otp: 'otp',
  resetPassword: 'resetPassword',
}

const Stack = createStackNavigator()
import Otp from '../../screens/Otp/';
import Login from '../../screens/Login';

const LoginNav = ({ route }: any) => {
  const deeplinkPath = route?.params?.navigateTo

  const navigation = useNavigation()

  useEffect(() => {
    const sessData = window?.localStorage.getItem('sessionData')
    const jfsUserId = window?.localStorage.getItem('jfsUserId')
    if (!deeplinkPath && sessData && sessData?.length > 0 && isSessionValid(safelyParseJSON(sessData)) && !!jfsUserId) {
      navigation?.reset({
        index: 0,
        routes: [{ name: Routes.DASHBOARD }],
      })
    }
  }, [deeplinkPath, navigation])

  return (
    <Stack.Navigator screenOptions={{ headerBackTitleVisible: false, headerMode: 'screen' }}>
      <Stack.Screen
        name={Routes.LOGIN}
        component={Login}
        options={{ headerShown: false, title: loginStrings.loginJiopay }}
        initialParams={deeplinkPath ? { navigateTo: deeplinkPath } : undefined}
      />
      <Stack.Screen
        name={LoginNavStrings.forgotPassword}
        component={ForgotPassword}
        options={{ headerShown: false, title: 'Forgot Password' }}
      />
      <Stack.Screen name={LoginNavStrings.otp} component={Otp} options={{ headerShown: false, title: 'OTP' }} />
      <Stack.Screen
        name={LoginNavStrings.resetPassword}
        component={ResetPassword}
        options={{ headerShown: false, title: 'Reset Password' }}
      />
    </Stack.Navigator>
  )
}

export default LoginNav
